export enum CreateFormKeys {
    Subject = 'subject',
    Product = 'product',
    Order = 'order',
    Message = 'message',
}
